import { action } from 'typesafe-actions';
import {
  FB_LOGIN_REQUEST,
  APPLE_LOGIN_REQUEST,
  LOGIN_FAILURE,
  LOGIN_INIT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  AUTO_LOGIN_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGIN_INIT_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  AUTO_LOGIN_REQUEST,
  AUTO_LOGIN_FAILURE,
  LOGIN_INIT_SUCCESS,
} from '../../constants/login';
import { Credentials } from '../../types/Login';

export const loginRequestAction = (credentials: string, redirect: string) => {
  return action(LOGIN_REQUEST, { credentials, redirect });
};
export const autoLoginRequestAction = (token: string, redirect: string) => {
  return action(AUTO_LOGIN_REQUEST, { token, redirect });
};

export const signupRequestAction = (
  email: string,
  password: string,
  country: string,
  currency: string,
  visitorID?: string,
) => {
  return action(SIGNUP_REQUEST, {
    email,
    password,
    country,
    currency,
    visitorID,
  });
};
export const fbLoginRequest = (accessToken: string) => {
  return action(FB_LOGIN_REQUEST, { accessToken });
};
export const appleLoginRequest = (
  accessToken: string,
  email?: string,
  username?: string,
) => {
  if (email && username) {
    return action(APPLE_LOGIN_REQUEST, { accessToken, email, username });
  } else return action(APPLE_LOGIN_REQUEST, { accessToken });
};

export const loginFailureAction = (e: any) => action(LOGIN_FAILURE, e);
export const autoLoginFailureAction = (e: any, redirect: string) =>
  action(AUTO_LOGIN_FAILURE, { e, redirect });
export const signupFailureAction = (e: any) => action(SIGNUP_FAILURE, e);
export const loginInitAction = () => action(LOGIN_INIT);
export const loginSuccessAction = (userData: Credentials, redirect = false) =>
  action(LOGIN_SUCCESS, { userData, redirect });
export const loginInitSuccessAction = (
  userData: Credentials,
  redirect = false,
) => action(LOGIN_INIT_SUCCESS, { userData, redirect });
export const autoLoginSuccessAction = (
  userData: Credentials,
  redirect: string,
) => {
  return action(AUTO_LOGIN_SUCCESS, { userData, redirect });
};
export const loginInitFailureAction = (e: any) => action(LOGIN_INIT_FAILURE, e);
export const signupSuccessAction = (userData: Credentials, redirect = false) =>
  action(SIGNUP_SUCCESS, { userData, redirect });

export const logoutRequestAction = () => action(LOGOUT_REQUEST);
export const logoutSuccessAction = () => action(LOGOUT_SUCCESS);
export const logoutFailureAction = () => action(LOGOUT_FAILURE);

export const loginActions = {
  loginRequestAction,
  signupRequestAction,
  signupSuccessAction,
  signupFailureAction,
  fbLoginRequest,
  appleLoginRequest,
  loginFailureAction,
  loginSuccessAction,
  loginInitAction,
  loginInitFailureAction,
  logoutRequestAction,
  logoutSuccessAction,
  logoutFailureAction,
  autoLoginRequestAction,
  autoLoginSuccessAction,
  autoLoginFailureAction,
  loginInitSuccessAction,
};
